import { FileOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import React from 'react';
import { tran } from '../../../../translations/schema/TranslationSchema';
import type { IWidgetType } from '../../../IWidgetType';
import {
  ISortableWidgetData,
  WidgetCategory,
  WidgetMainType,
  WidgetType,
} from '../../../Widget';
import { isContainerData } from '../../containers/IContainerWidget';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema';
import { IPageWidget } from './IPageWidget';
import { PageWidgetComponent } from './PageWidgetComponent';
import { PageWidgetPreview } from './PageWidgetPreview';

const configValidator = CommonGraphicWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Page).required(),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IPageWidget>;

/**
 * Tipo del componente di visualizzazione di un divisore per il titolo.
 */
export const PageWidgetType: IWidgetType<IPageWidget> = {
  type: WidgetType.Page,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Divisione di Pagina',
  icon: <FileOutlined />,
  hasValue: false,
  formComponent: PageWidgetComponent,
  configComponent: null,
  configValidator: configValidator,
  previewComponent: PageWidgetPreview,
  translationSchema: tran.widget({
    helpText: tran.rte(),
  }),
  rules: [],
  isValidParent: (_, parent, parentData?: ISortableWidgetData) => {
    const isParentInRoot = !parent.path?.length || parent.path?.length === 0;
    // La pagina può essere posizionata _solo_ nella root, sopra a un qualuqnue widget _non_ contenitore
    // N.B. gli extra-droppable dei container sono di tipo 'other' quindi sono aree valide per la pagina
    // in questo modo è possibile spostare la pagina _tra_ i container (sempre se sono nella root)
    return !isContainerData(parentData) && isParentInRoot;
  },
};
